/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
  extensaoArquivo: string;
  base64: string;
}

export function useAnexarLaudo() {
  const postData = async (props: Props) => {
    const ANEXAR_LAUDO = `${backofficeEnviroment}/common/backoffice/upload-laudo/v1`;
    const { data } = await instance.put(ANEXAR_LAUDO, {
      idOportunidade: props.idOportunidade,
      extensaoArquivo: `.${props.extensaoArquivo}`,
      base64: props.base64,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Laudo anexado com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao anexar laudo. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
